module.exports = __webpack_public_path__ + "static/media/applet1.dd5f680c.png";